export default __webpack_public_path__ + "static/media/ProfileIcon.69d376a0.png";